import script from "./AUDIT_COMMENT_STRUCTURED_DESCRIPTION_CHANGED.vue?vue&type=script&setup=true&lang=ts"
export * from "./AUDIT_COMMENT_STRUCTURED_DESCRIPTION_CHANGED.vue?vue&type=script&setup=true&lang=ts"

import "./AUDIT_COMMENT_STRUCTURED_DESCRIPTION_CHANGED.vue?vue&type=style&index=0&id=03aad32f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03aad32f"]])

export default __exports__